// /src/store/modules/forms.js
import CommonGetters from '@/store/common/getters'
import { optionsStore } from '@/services/Storage'
import { apiFormSubmit, apiGet } from '@/services/FormAPIService'
import _isArray from 'lodash/isArray'

export const namespaced = true

export const state = {
  forms: {
    data: [],
  },
}

export const mutations = {
    GET_FORMS(state, forms) {
      state.forms.data.push(forms)
    },
}

export const actions = {
    async getAll({state, commit}) {
        const output = {}
        const forms = await apiGet('contact-forms')
        forms.data.forEach(async item => {
            const itemID = item.id
            const form = await apiGet('contact-forms/' + itemID)
            output[itemID] = form.data
            commit('GET_FORMS', output)
        })
    },

    async submitForm({dispatch}, payload) {
        // apiForm
        const formURL = `contact-forms/${payload.id}/feedback`
        const formResponse = await apiFormSubmit(formURL, payload.submission)
        let messageType = 'success'
        switch (formResponse.data.status) {
            case "mail_failed":
                messageType = 'error'
                break;
        
            default:
                break;
        }

        dispatch(
            'notification/add',
            {
              type: messageType,
              msg: formResponse.data.message,
              closable: false,
              autoClose: true,
            },
            { root: true },
        )

        return formResponse

    }
}

export const getters = {
    
    findFormByID: (state) => async (array = [0], propKey = 'id') => {
        const collection = []
        const forms = await state['forms'].data
        let i = 0
        do {
            const item = forms.find(
                item => item[propKey] == array[i],
            )
            console.log(forms)
            collection.push(typeof item != 'undefined' ? item : {})
            i++
        } while (i < array.length)
        return collection
    },  
      
}